import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ICS204_OUTLINE_BTN } from './assignmentCardStyles';
import { Ics204DisabledActionTooltip } from './Ics204DisabledActionTooltip';

type ResourceSectionAddButtonsProps = {
  disabled?: boolean;
  disabledReason?: string | null;
  onAddResource: () => void;
  onAddFromRoster: () => void;
  onAddDocumentationEntry: () => void;
};

/** Section 5 header actions, shared by the read-only and edit resource tables. */
const ResourceSectionAddButtons = ({
  disabled = false,
  disabledReason = null,
  onAddResource,
  onAddFromRoster,
  onAddDocumentationEntry,
}: ResourceSectionAddButtonsProps) => {
  const triggerButton = (
    <Button
      type="button"
      size="sm"
      variant="outline"
      className={ICS204_OUTLINE_BTN}
      data-testid="ics204-add-resources-dropdown"
      disabled={disabled}
    >
      + Add
      <ChevronDown className="tw:h-4 tw:w-4" />
    </Button>
  );

  if (disabled) {
    const disabledTrigger = disabledReason ? (
      <Ics204DisabledActionTooltip reason={disabledReason}>
        {triggerButton}
      </Ics204DisabledActionTooltip>
    ) : (
      triggerButton
    );
    return (
      <div className="tw:mb-2 tw:flex tw:flex-row tw:items-center tw:gap-2">
        {disabledTrigger}
      </div>
    );
  }

  return (
    <div className="tw:mb-2 tw:flex tw:flex-row tw:items-center tw:gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger render={triggerButton} />
        <DropdownMenuContent
          align="start"
          className="dark tw:border-[var(--border-primary)] tw:bg-black tw:text-foreground"
        >
          <DropdownMenuItem
            data-testid="ics204-attach-resources-button"
            onClick={onAddResource}
          >
            + Add Resource
          </DropdownMenuItem>
          <DropdownMenuItem
            data-testid="ics204-add-from-roster-button"
            onClick={onAddFromRoster}
          >
            + Add From Roster
          </DropdownMenuItem>
          <DropdownMenuItem
            data-testid="ics204-add-documentation-entry-button"
            onClick={onAddDocumentationEntry}
          >
            + Add Documentation Entry
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ResourceSectionAddButtons;
